module.exports = __webpack_public_path__ + "img/10.8d98b3f9.jpg";